import React from "react";

const BasicDetails = ({ data }) => {
  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
      <h2 className="text-lg font-medium mb-4 underline text-[#333333]">
        Basic Details
      </h2>
      <table className="w-full ">
        <tbody>
          <tr className="">
            <td className="p-3 font-medium text-sm text-[#333333]">
              Company ID:
            </td>
            <td className="p-3 text-sm text-[#333333]">{data.company_id}</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Company Name:
            </td>
            <td className="p-3 text-sm text-[#333333]">{data.company_name}</td>
          </tr>
          <tr className="">
            <td className="p-3 font-medium text-sm text-[#333333]">
              Company Website URL:
            </td>
            <td className="p-3 text-sm text-[#333333]">www.Emayamtech.com</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Nature Of Business:
            </td>
            <td className="p-3 text-sm text-[#333333]">Manufacture</td>
          </tr>
          <tr className="">
            <td className="p-3 font-medium text-sm text-[#333333]">
              Primary Email ID:
            </td>
            <td className="p-3 text-sm text-[#333333]">abucr3@gmail.com</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Additonal Email ID:
            </td>
            <td className="p-3 text-sm text-[#333333]">abucr3@gmail.com</td>
          </tr>
          <tr className="">
            <td className="p-3 font-medium text-sm text-[#333333]">
              Primary Contact Number:
            </td>
            <td className="p-3 text-sm text-[#333333]">+91 6381998365</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Additional Contact Number:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Company LinkedIn URL:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BasicDetails;